import React from 'react'

const CRUDTitle = (props) => {
  return (
    <div>
      <h5 style={{marginBottom: 4}}><b>{props.title}</b></h5>
      <hr style={{marginTop: 0, marginBottom: 10}}/>
    </div>
  )
}

export default CRUDTitle



/** WEBPACK FOOTER **
 ** ./modules/shared/crud_title.js
 **/